class PharmacyLocator {
    container;
    map;
    defaultLat;
    defaultLng;
    defaultZoom;
    zoomLocality;
    zoomMarkerClick;
    autocomplete = null;
    pharmacies = [];
    filters;
    phList;
    hasZoomed;
    phDetails;
    showProps;
    phResults;
    infoWindow;
    dontLoadPharmacies = false;
    userPhCode;
    mapStyles = [
        { "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }] },
        { "elementType": "labels.icon", "stylers": [{ "visibility": "on" }] },
        { "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] },
        { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f5f5" }] },
        { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#bdbdbd" }] },
        { "featureType": "poi", "stylers": [{ "visiblity": "off" }] },
        { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] },
        { "featureType": "poi", "elementType": "labels.icon", "stylers": [{ "saturation": -100 }] },
        { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] },
        { "featureType": "poi", "stylers": [{ "visibility": "off" }] },
        { "featureType": "poi.medical", "stylers": [{ "visibility": "on" }] },
        { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] },
        { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] },
        { "featureType": "road.arterial", "elementType": "labels", "stylers": [{ "visibility": "on" }] },
        { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] },
        { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#dadada" }] },
        { "featureType": "road.highway", "elementType": "labels", "stylers": [{ "visibility": "on" }] },
        { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] },
        { "featureType": "road.local", "stylers": [{ "visibility": "on" }] },
        { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] },
        { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] },
        { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] },
        { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#c9c9c9" }] },
        { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }
    ];
    constructor(section) {
        this.container = section;
        this.map = this.container.querySelector('#ph-map');
        this.defaultLat = parseFloat(this.container.getAttribute('data-default-lat'));
        this.defaultLng = parseFloat(this.container.getAttribute('data-default-lng'));
        this.defaultZoom = parseInt(this.container.getAttribute('data-default-zoom'));
        this.zoomLocality = parseInt(this.container.getAttribute('data-zoom-locality'));
        this.zoomMarkerClick = parseInt(this.container.getAttribute('data-zoom-marker-click'));
        this.enableSearchMarker = this.container.getAttribute('data-enable-search-marker') === 'true' ? true : false;
        this.countryArray = this.container.getAttribute('data-country-array');
        this.phList = this.container.querySelector('[ph-map-list]');
        this.phDetails = this.container.querySelector('[ph-map-details]');
        this.showProps = JSON.parse(this.container.getAttribute("data-contacts-show"));
        this.userPosition = new UserPosition(this.container.querySelector('[ph-map-search]'));
        this.filters = new Filters(this.container.querySelectorAll('[ph-map-filter]'));
    }
    async init() {
        this.toggleLoader(this.container.querySelector('.ph-map__map-container'), true);
        this.checkGetParams();
        await this.setUserCoordinates(false);
        await this.initMap();
        this.initSearchAutoComplete();
        this.initFilters();
        this.initEventListeners();
        this.toggleLoader(this.container.querySelector('.ph-map__map-container'), false );
    }
    /**
     * Init all pharmacy locator event listeners
     *
     * @return  {Void}
     */
    initEventListeners() {
        this.initFindMyPositionEvent();
        this.initPhDetailsEvents();
        this.initSetPharmacyEvent();
        this.initHighlightMarkerEvent();
        this.initItemEvents();
        this.initSwitchMapListEvents();
    }

    checkGetParams() {
        const queryString = new URL(window.location);
        const urlParams = new URLSearchParams(queryString.search);
        if(queryString != ''){
            const serviceParameter = 'service';
            if (urlParams.get(serviceParameter) != null) {
                let qstrService = urlParams.get(serviceParameter);
                if(qstrService!=''){
                    this.serviceParam = qstrService;
                }
            }
        }

        if(queryString != ''){
            const typeParameter = 'type';
            if (urlParams.get(typeParameter) != null) {
                let qstrType = urlParams.get(typeParameter);
                if(qstrType!=''){
                    this.typeParam = qstrType;
                }
            }
        }
    }
    /**
     * Init map, set markers, init infoWindow
     * and get filtered pharmacy when
     * map is in idle state
     *
     * @return  {Void}
     */
    async initMap() {
        if (this.map) {
            await this.checkPharmaciesLoaded();

            const userLocEmpty = this.userPosition.isUserLocEmpty(),
                  centerCoords = userLocEmpty ? new google.maps.LatLng(this.defaultLat, this.defaultLng) : new google.maps.LatLng(this.userPosition.lat, this.userPosition.lng);
            this.map = new google.maps.Map(this.map, {
                center: centerCoords,
                zoom: userLocEmpty ? this.defaultZoom : this.zoomLocality,
                disableDefaultUI: true,
                mapTypeControl: false,
                zoomControl: true,
                zoomControlOptions: {
                  position: google.maps.ControlPosition.RIGHT_BOTTOM,
                },
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                gestureHandling: 'cooperative',
                styles: this.mapStyles
            });

            //set user position marker
            this.setMarker(this.userPosition.lat, this.userPosition.lng, 'You', theme.pharmacyLocator['svg']['myPosition']);

            this.populateMap();
            //init infoWindow
            this.infoWindow = new google.maps.InfoWindow();
            google.maps.event.addListener(this.infoWindow, 'content_changed', () => {
                this.dontLoadPharmacies = true;
            });
            google.maps.event.addListener(this.map, 'idle', () => {
                if (!this.dontLoadPharmacies) {
                    this.showResults();
                }
                this.dontLoadPharmacies = false;
                this.hasZoomed = false;
            });
            google.maps.event.addListener(this.map, 'dragend', () => this.trackGTMEvent('search', '', 'map scroll'));
            google.maps.event.addListener(this.map, 'zoom_changed', () => this.hasZoomed = true);
        }
    }
    /**
     * Set initial coordinates:
     * get user position coordinates,
     * set it in map and show address in search input
     * @param {Boolean} setMapCenter
     *
     * @return  {Void}
     */
    async setUserCoordinates(setMapCenter) {
        if (this.userPosition.isUserLocEmpty()) {
            await this.userPosition.getGeoPosition();
        }
        this.userPosition.setAddressInSearch();

        //if geo position active then scroll to search input
        if (!this.userPosition.isUserLocEmpty() && typeof window.goToPos === 'function'){
            //on mobile visible map
            if (window.innerWidth < 1025) {
                if (typeof window.goToPos === 'function') goToPos('.ph-map__pharmacy_type');
            } else {
                goToPos('.ph-map__search-container');
            }
        };

        if (setMapCenter) {
            this.setMapCenter(new google.maps.LatLng(this.userPosition.lat, this.userPosition.lng), this.zoomLocality);
        }
    }
    /**
     * Initialize Search autocomplete input
     *
     * @return  {Void}
     */
    initSearchAutoComplete() {
        const input = this.container.querySelector('[ph-map-search]');
        const options = {
            componentRestrictions: { 'country': [this.countryArray] },
            types: ['geocode']
        };
        this.autocomplete = new google.maps.places.Autocomplete(input, options);
        this.setAutoCompleteEvent(input);

        input.addEventListener('click', () => {
            if(typeof window.goToPos === 'function') goToPos('.ph-map__input__search__text', 155);
        })
    }
    /**
     * Add listener when place change and
     * set place coordinates
     *
     * @return  {Void}
     */
    setAutoCompleteEvent(searchInput) {
        google.maps.event.addListener(this.autocomplete, 'place_changed', async () => {
            const place = this.autocomplete.getPlace();
            const address = searchInput.value;
            let originLocation = null;
            // if user enter the name of a Place that was not suggested and
            // pressed the Enter key, or the Place Details request failed.
            if (!place.geometry) {
                await new Promise((resolve, reject) => {
                    const geocoder = new google.maps.Geocoder();
                    geocoder.geocode({ 'address': address }, function (results, status) {
                        if (status == 'OK') {
                            const lat = results[0].geometry.location.lat();
                            const lng = results[0].geometry.location.lng();
                            originLocation = new google.maps.LatLng(lat, lng);
                            resolve();
                        } else reject(error);
                    });
                }).catch(error => console.warn(error));
            } else {
                originLocation = place.geometry.location;
            }
            if (window.innerWidth < 1025) {
                if (typeof window.goToPos === 'function') goToPos('.ph-map__pharmacy_type');
            }
            this.setMapCenter(originLocation, this.zoomLocality);
            if(this.enableSearchMarker){
                this.setSearchMarker(originLocation);
            }
            this.trackGTMEvent('search', '', 'input search');
        });
    }
    /**
     * Initialize geo localization position button
     *
     * @return  {Void}
     */
    initFindMyPositionEvent() {
        let self = this;
        self.container.querySelector('[ph-map-search-geolocation]').addEventListener('click', () => {
            self.setUserCoordinates(true);
            self.trackGTMEvent('search', '', 'gps search');
        });
    }
    /**
     * init showmore filters if more than 3,
     * init filter events
     *
     * @return  {Void}
     */
    initFilters() {
        this.filters.initFiltersShowMore(this.container.querySelector('[ph-map-filters-more]'));
        this.initFilterEvents(this.filters.options);
        this.filters.options.forEach((option) => {
            if (option.value === this.typeParam) {
                option.setAttribute('checked', true);
                option.dispatchEvent(new Event('change'));
            }
            if (option.value === this.serviceParam ) {
                option.setAttribute('checked', true);
                option.dispatchEvent(new Event('change'));
            }
        });

    }
    /**
     * Set 'change' filters event and
     * update active options
     *
     * @return  {Void}
     */
    initFilterEvents(options) {
        options.forEach((option) => {
            option.addEventListener('change', () => {
                if (option.hasAttribute('ph-type')) this.filters.pharmacyType = option.checked ? 1 : 0;
                else option.checked ? this.filters.addActiveOption(option.value) : this.filters.removeActiveOption(option.value);
                this.filterMap();
            });
        });
    }
    /**
     * init mobile switch map/list events
     *
     * @return  {Void}
     */
    initSwitchMapListEvents() {
        this.container.querySelector("#ph-map-switches .ph-map-switches__switch__map").addEventListener('click',() => {
            this.container.querySelector(".ph-map__map-container").classList.remove('visible');
            this.container.querySelector(".ph-map__map-canvas").classList.remove('not-visible');
            this.phList.classList.remove('visible');
            this.container.querySelector(".ph-map__map-container").classList.add('visible');
            this.container.querySelector(".ph-map-switches__switch__pharmacies").classList.remove('visible');
            this.container.querySelector(".ph-map-switches__switch__map").classList.add('visible');
            this.container.querySelector(".ph-map__results").classList.add('not-visible');
        });
        this.container.querySelector("#ph-map-switches .ph-map-switches__switch__pharmacies").addEventListener('click',() => {
            this.container.querySelector(".ph-map__map-container").classList.remove('visible');
            this.phList.classList.add('visible');
            this.container.querySelector(".ph-map__map-canvas").classList.add('not-visible');
            this.container.querySelector(".ph-map-switches__switch__pharmacies").classList.add('visible');
            this.container.querySelector(".ph-map-switches__switch__map").classList.remove('visible');
            this.container.querySelector(".ph-map__results").classList.remove('not-visible');
            if (this.container.querySelector('.ph-map__item.active') != null) {
                this.container.querySelector('.ph-map__ph__list').scrollTop = this.container.querySelector('.ph-map__item.active').offsetTop;
            }
        });

        this.container.querySelector("#ph-map-switches .ph-map-switches__switch__map").dispatchEvent(new Event('click'));
    }
    /**
     * await for pharmacies to be loaded, then resolve promise
     * if not loaded, reject after 5 seconds
     *
     * @return  {Void}
     */
    async checkPharmaciesLoaded() {
        if (localStorage.getItem('pharmacies') === null ) {
            await new Promise((resolve, reject) => {
                this.container.addEventListener('pharmaciesLoaded', () => {
                    resolve();
                }, { once: true });
                setTimeout(() => {
                    console.warn('Pharmacies not loaded');
                    reject();
                }, 5000);
            });
        }
    }
    /**
     * get all pharmacies from localStorage,
     * set markers and init markerClusters
     *
     * @return  {Void}
     */
    populateMap() {
        const pharmacies = JSON.parse(localStorage.getItem('pharmacies'));
        if (pharmacies !== null && pharmacies.length > 0) {
            pharmacies.forEach((pharmacy) => {
                let pharmacyObject = new Pharmacy(pharmacy);
                pharmacyObject.marker = this.setMarker(pharmacyObject.lat, pharmacyObject.lng, pharmacyObject.nomeFarmacia, pharmacyObject.markerIcons.default);
                this.initMarkerEvents(pharmacyObject);
                this.pharmacies.push(pharmacyObject);
            });
            this.markersClusters = new MarkerClusterer( this.map, this.pharmacies.map(pharmacy => pharmacy.marker), {
                gridSize: 100,
                maxZoom: this.zoomLocality + 1,
                styles: [
                    {
                        url: theme.pharmacyLocator['svg']['cluster'],
                        height: 40,
                        width: 40,
                        anchor: [0,0],
                        textColor: '#fff',
                        textSize: 12
                    }
                ]
            });
        }
    }
    /**
     * filter markers visible in maps and recreate clusters
     *
     * @return  {Void}
     */
    filterMap() {
        const filteredPharmacies = this.pharmacies.filter((pharmacy) => {
            return this.setPhVisibility(pharmacy);
        });
        this.markersClusters.clearMarkers();
        this.markersClusters = new MarkerClusterer( this.map, filteredPharmacies.map(pharmacy => pharmacy.marker), {
            gridSize: 100,
            maxZoom: 10,
            styles: [
                {
                    url: theme.pharmacyLocator['svg']['cluster'],
                    height: 40,
                    width: 40,
                    anchor: [0,0],
                    textColor: '#fff',
                    textSize: 12
                }
            ]
        });
        this.trackGTMEvent('search', '', 'filter search');
        this.showResults();
    }
    /**
     * get pharmacies in view and create pharmacy boxes
     *
     * @return  {Void}
     */
    showResults() {
        const mapBounds = this.getMapBounds(),
              mapCenter = this.map.getCenter();
        this.pharmacyListHtml = '';
        this.phResults = [];

        this.phResults = this.pharmacies.filter((pharmacy) => {
            if (mapBounds.contains({lat: pharmacy.lat, lng: pharmacy.lng}) && pharmacy.isVisible) {
                pharmacy.setDistance(mapCenter);
                return true;
            }
        }).sort((a,b) => (a.distanceFromCenter - b.distanceFromCenter))
        .sort((a, b) => (b.selectable - a.selectable));

        if(!this.hasZoomed) this.resetHighlightedMarkers();

        const self = this;

        this.phResults.forEach((pharmacy,index) => {
            this.pharmacyListHtml += pharmacy.createPharmacyBox(index, self);
            this.phList.scrollTop = 0;
        });
        this.container.querySelector('[ph-map-n-results] span').innerHTML = `${this.phResults.length} ${theme.pharmacyLocator['strings']['pharmaciesFound']}`;
        this.phList.innerHTML = this.pharmacyListHtml;
        this.phResults.length === 0 ? this.popupNoResult() : null;
    }
    /**
     * check if pharmacy marker has to be shown in map
     * @param {Pharmacy} pharmacy
     *
     * @return  {Boolean}
     */
    setPhVisibility(pharmacy) {
        // check pharmacy type
        if(this.filters.pharmacyType == 1 && pharmacy.aderenteReteFP != 1 ) {
            pharmacy.marker.setVisible(false);
            pharmacy.isVisible = false;
            return false;
        } else if(!this.filters.activeOptions.every(services => pharmacy.serviceFilters.includes(services)) &&
            this.filters.options.length != this.filters.activeOptions.length &&
            this.filters.activeOptions.length > 0) {
            pharmacy.marker.setVisible(false);
            pharmacy.isVisible = false;
            return false;
        } else {
            pharmacy.marker.setVisible(true);
            pharmacy.isVisible = true;
            return true;
        }
    }
    /**
     * No visible pharmacy popup
     */
    popupNoResult() {
        const modal = document.getElementById("ph_empty_view");
        const modalInner = document.querySelector("#ph_empty_view .modal__wrapper");
        setTimeout(()=> modal.style.display = "block", 500);
        const closeModal = document.querySelector("#ph_empty_view span.close");
        closeModal.onclick = function() {
          modal.style.display = "none";
        }
        window.onclick = function(event) {
          if (event.target == modalInner) {
            modal.style.display = "none";
          }
        }
    }

    /**
     * init pharmacy details open, and back to list events
     *
     * @return  {Void}
     */
    initPhDetailsEvents() {
        const self = this;
        document.addEventListener('click', async (event) => {
            if (event.target.hasAttribute('ph-map-detail')) {
                const phDetails = await window.pharmacies.getPharmacy(event.target.getAttribute('data-ph-id'));
                if (phDetails != null) {
                    if (event.target.hasAttribute('info-window-detail')) {
                        this.container.querySelector("#ph-map-switches .ph-map-switches__switch__pharmacies").dispatchEvent(new Event('click'));
                    }
                    const phDetailsObject = new PharmacyDetails(phDetails);
                    this.phDetails.querySelector('[ph-map-details-inner]').innerHTML = phDetailsObject.createPharmacyDetails(self);
                    this.phDetails.classList.add('open');
                    if (window.innerWidth < 1025) {
                        setTimeout(() => {
                            this.container.querySelector('.ph-map__interface').scrollIntoView({ behavior: "smooth", block: "end"});
                        }, 1000);
                    }
                }
            }
        });

        //back to list event
        this.container.querySelector("[ph-map-back-to-list]").addEventListener('click', () => this.phDetails.classList.remove('open'));
    }
    /**
     * init set pharmacy event
     *
     * @return  {Void}
     */
    initSetPharmacyEvent() {
        document.addEventListener('click', (event) => {
            if (event.target.hasAttribute('ph-map-set-ph')) {
                const target = event.target;
                const location = target.getAttribute('ph-set-type');
                window.pharmacies.setPharmacy(target.getAttribute('data-ph-id'), false, location);
            }
        });
    }

    /**
     * init Item events
     *
     * @return  {Void}
     */
    initItemEvents() {
        document.addEventListener('click', (event) => {
            if(event.target.hasAttribute('data-gtm-type')){
                const target = event.target;
                const phId = target.closest('[ph-gtm-item]').getAttribute("data-ph-id");
                const pharmacy = this.phResults.find(item => item.codiceX3 == phId);
                const gtmType = target.getAttribute('data-gtm-type');

                this.trackGTMEvent('phContacts', pharmacy, gtmType, '');
            }
        });
    }
    /**
     * init highlight marker and zoom map event
     *
     * @return  {Void}
     */
    initHighlightMarkerEvent() {
        document.addEventListener('click', (event) => {
            if (event.target.hasAttribute('ph-map-highlight-marker')) {
                this.resetHighlightedMarkers();
                const pharmacy = this.phResults.find(item => item.codiceX3 == event.target.getAttribute('data-ph-id'));
                if (pharmacy != null) {
                    const phBox = event.target.closest('[ph-map-item]');
                    if (phBox != null) {
                        phBox.classList.add('active');
                        this.phList.scrollTop = phBox.offsetTop;
                    }
                    if (window.innerWidth < 1025) {
                        this.container.querySelector("#ph-map-switches .ph-map-switches__switch__map").dispatchEvent(new Event('click'));
                        const phBoxActive = this.phList.querySelector(`.ph-map__item[data-ph-id="${pharmacy.codiceX3}"]`);
                        if (phBoxActive != null) {
                            phBoxActive.classList.add('active');
                            this.setInfoWindow(pharmacy);
                            this.highlightMarker(pharmacy, true);
                            this.phList.scrollTop = phBoxActive.offsetTop;
                        }
                    }
                    this.highlightMarker(pharmacy, true);
                    this.dontLoadPharmacies = true;
                    this.setMapCenter(new google.maps.LatLng(pharmacy.lat, pharmacy.lng), this.zoomMarkerClick);
                }
            }
        });
    }
    /**
     * set marker events: click opens infoWindow on mobile
     * highlight marker and zoom map
     * @param {Pharmacy} pharmacy
     *
     * @return {Void}
     */
    initMarkerEvents(pharmacy) {
        pharmacy.marker.addListener("click", () => {
            this.resetHighlightedMarkers();
            const phBoxActive = this.phList.querySelector(`.ph-map__item[data-ph-id="${pharmacy.codiceX3}"]`);
            if (phBoxActive != null) {
                phBoxActive.classList.add('active');
                this.setInfoWindow(pharmacy);
                this.highlightMarker(pharmacy, true);
                this.phList.scrollTop = phBoxActive.offsetTop;
            }
        });
    }
     /**
     * set search marker
     * @param {Number}  lat
     * @param {Number}  lng
     *
     * @return  {Void}
     */
        setSearchMarker(position) {
            if (!this.searchMarker) {
                this.searchMarker = new google.maps.Marker({
                    map: this.map,
                    position: position
                });
            } else {
                this.searchMarker.setPosition(position);
            }
            this.searchMarker.setVisible(true);
        }
    /**
     * set marker in map
     * @param {Number}  lat
     * @param {Number}  lng
     * @param {String}  title
     * @param {String}  icon
     *
     * @return  {Object}
     */
    setMarker(lat,lng,title,icon) {
        return new google.maps.Marker({
            position: {lat: lat, lng: lng},
            map: this.map,
            title: title,
            icon: icon
        });
    }
    /**
     * set active icon marker and bounce animation
     * @param {Pharmacy} pharmacy
     * @param {Boolean} highlight
     *
     * @return  {Void}
     */
    highlightMarker(pharmacy, highlight) {
        if (pharmacy != null) {
            const icon = highlight ? pharmacy.markerIcons.active : pharmacy.markerIcons.default,
                  animation = highlight ? google.maps.Animation.BOUNCE : null;
            pharmacy.marker.setIcon(icon);
            pharmacy.marker.setAnimation(animation);
            pharmacy.isActive = highlight;
        }
    }
    /**
     * reset all highlighted markers in map
     *
     * @return  {Void}
     */
    resetHighlightedMarkers() {
        this.phResults.find(ph => {
            if(ph.isActive){
                this.highlightMarker(ph, false);
                const activePharmacy = this.phList.querySelector(`.ph-map__item[data-ph-id=${ph.codiceX3}]`);
                if(!!activePharmacy) activePharmacy.classList.remove('active');
            }
        });
    }
    /**
     * create and open marker infoWindow only on mobile
     * @param {Pharmacy} pharmacy
     *
     * @return {Void}
     */
    setInfoWindow(pharmacy) {
        if (window.innerWidth < 1025) {
            this.infoWindow.setContent(pharmacy.createInfoWindowContent());
            this.infoWindow.open(this.map, pharmacy.marker);
        }
    }
    /**
     * calculate radius of visible part of the map
     *
     * @return  {Number}
     */
    getMapBounds() {
        const bounds = this.map.getBounds();
        if (bounds != null) {
            const SW = bounds.getSouthWest(),
                  NE = bounds.getNorthEast();
            return new google.maps.LatLngBounds(new google.maps.LatLng(SW.lat(), SW.lng()), new google.maps.LatLng(NE.lat(), NE.lng()));
        }
        return 0;
    }
    /**
     * set center of map and zoom
     * @param  {Object} coordinates
     * @param  {Number} zoom
     *
     * @return {Void}
     */
    setMapCenter(coordinates, zoom) {
        this.map.setCenter(coordinates);
        if (zoom) this.map.setZoom(zoom);
    }
    /**
     * enable or disable loader
     * @param  {Element} context
     * @param  {Boolean} enable
     *
     * @return {Void}
     */
    toggleLoader(context, enable) {
        if (context != null) {
            const loaderWrapper = context.querySelector('.loader-wrapper');
            if (loaderWrapper != null) enable ? loaderWrapper.classList.add('loading') : loaderWrapper.classList.remove('loading');;
        }
    }
    trackGTMEvent(event_type, pharmacy, search_type, pharmacies_displayed){
        var search_city = $(".ph-map__inputs-container [ph-map-search]").val();
        var filter_service = $(":is(.ph-map__filters__container, .ph-map__pharmacy_type) [ph-map-filter]:checked").map(function() { return this.nextElementSibling.innerHTML }).get().join(',') || 'Farmacie Specializzate';
        var position = $('.showPharmacy[data-code="' + pharmacy.CodiceX3 + '"]').data('position');
        if (typeof GTM != 'undefined') {
            switch (event_type) {
                case 'search':
                    if (dataLayer[dataLayer.length -1].searchType !== 'input search') GTM.trackLocatorSearch(search_city, filter_service, search_type);
                    break;
                case 'phContacts':
                    GTM.trackPharmacyDetailsContacts(pharmacy, search_type);
                    break;
                default:
                    return false;
            }
        }
    }
}

class UserPosition {
    #searchInput;
    #lat;
    #lng;
    #address;
    constructor(searchInput) {
        this.#searchInput = searchInput;
    }
    get lat() {
        return this.#lat;
    }
    set lat(value) {
        this.#lat = value;
    }
    get lng() {
        return this.#lng;
    }
    set lng(value) {
        this.#lng = value;
    }
    /**
     * check if we have user location
     *
     * @return  {Void}
     */
    isUserLocEmpty() {
        return this.#lat != null && this.#lng != null && this.#address != null ? false : true;
    }
    /**
     * Set address on input search
     *
     * @return  {Void}
     */
    setAddressInSearch() {
        if (this.#address != null) {
            this.#searchInput.value = this.#address;
        }
    }
    /**
     * get browser location position and set user coordinates
     *
     * @return  {Void}
     */
    async getGeoPosition() {
        const geoOptions = {
            enableHighAccuracy: true,
            timeout:    6000,   // time in millis when error callback will be invoked
            maximumAge: 0       // max cached age of gps data, also in millis
        };
        await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(
                async pos => {
                    if(pos.coords.latitude != 0 && pos.coords.longitude != 0) {
                        this.#lat = pos.coords.latitude;
                        this.#lng = pos.coords.longitude;
                        this.#address = await this.#getGeoAddress();
                    }
                    resolve(pos);
                },
                err => {
                    reject(err);
                },
                geoOptions
            );
        }).catch(error => console.warn(error));
    }
    /**
     * get user address
     *
     * @return  {Promise}
     */
    async #getGeoAddress() {
        return await new Promise((resolve, reject) => {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode( { 'location': { lat: this.#lat, lng: this.#lng}}, (results, status) => {
                (status === 'OK' && results[0]) ? resolve(results[0].formatted_address) : reject(new Error(status));
            });
        }).catch(error => console.warn(error));
    }
}

class Filters {
    activeOptions = [];
    options;
    pharmacyType = 0;
    constructor(filters) {
        this.options = filters;
    }
    /**
     * push new filter option
     * @param {String} optionValue
     *
     * @return  {Void}
     */
    addActiveOption(optionValue) {
        if (optionValue != '') this.activeOptions.push(optionValue);
    }
    /**
     * delete given option from filters
     * @param {String} optionValue
     *
     * @return  {Void}
     */
    removeActiveOption(optionValue) {
        this.activeOptions = this.activeOptions.filter((activeOption) => {
            return activeOption != optionValue;
        });
    }
    /**
     * init show more button on filters
     * @param {HTMLElement} optionValue
     *
     * @return  {Void}
     */
    initFiltersShowMore(moreFilters) {
        if (moreFilters != null) {
            const parent = moreFilters.closest('.ph-map__filters__container');
            const hiddenItems = parent.querySelectorAll('.hidden-filter');

            let isHidden = true;
            moreFilters.addEventListener('click', () => {
                moreFilters.querySelector('.ph-map__filter__label').textContent = isHidden ? `${theme.pharmacyLocator['strings']['hideServices']}` : `${theme.pharmacyLocator['strings']['showServices']}`;
                isHidden = !isHidden;
                hiddenItems.forEach(item => item.classList.toggle('hidden'));
            });
        }
    }
}

class Pharmacy {
    #aderenteReteFP;
    #cap;
    #categoriesFilters;
    #citta;
    #codiceX3;
    distanceFromCenter;
    #lat;
    #lng;
    #nomeFarmacia;
    #provincia;
    #selectable;
    #serviceDetails;
    #serviceFilters;
    #telefono;
    #via;
    isVisible = true;
    isActive = false;
    marker;
    markerIcons = {
        default: {
            url: theme.pharmacyLocator['svg']['markerDefault']
        },
        active: {
            url: theme.pharmacyLocator['svg']['markerActive']
        }
    };
    constructor(pharmacy) {
        this.#aderenteReteFP = pharmacy.AderenteReteFP;
        this.#cap = pharmacy.CAP;
        this.#categoriesFilters = pharmacy.CategoriesFilters;
        this.#citta = pharmacy.Citta;
        this.#codiceX3 = pharmacy.CodiceX3;
        this.#lat = pharmacy.Latitudine;
        this.#lng = pharmacy.Longitudine;
        this.#nomeFarmacia = pharmacy.NomeFarmacia;
        this.#provincia = pharmacy.Provincia;
        this.#selectable = pharmacy.Selectable == 1 ? true : false;
        this.#serviceDetails = pharmacy.ServicesDetails;
        this.#serviceFilters = pharmacy.ServicesFilters;
        this.#telefono = pharmacy.Telefono;
        this.#via = pharmacy.Via;
    }
    get aderenteReteFP() {
        return this.#aderenteReteFP;
    }
    get lat() {
        return this.#lat;
    }
    get lng() {
        return this.#lng;
    }
    get nomeFarmacia() {
        return this.#nomeFarmacia;
    }
    get codiceX3() {
        return this.#codiceX3;
    }
    get serviceDetails() {
        return this.#serviceDetails;
    }
    get serviceFilters() {
        return this.#serviceFilters;
    }
    get selectable() {
        return this.#selectable;
    }
    get telefono() {
        return this.#telefono;
    }
    isPharmacyActive() {
        return window.pharmacies.userPhCode == this.#codiceX3;
    }
    setDistance(mapCenter) {
        this.distanceFromCenter = this.#getDistanceFromLatLonInKm(mapCenter.lat(),mapCenter.lng(),this.#lat,this.#lng);
    }
    getAddress() {
        return `${this.#via.toLowerCase()} - ${this.#cap.toLowerCase()} ${this.#citta.toLowerCase()} (${this.#provincia.toUpperCase()})`;
    }
    #getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
        const deg2rad = deg => deg * (Math.PI/180),
            R = 6371; // Radius of the earth in km
        let dLat = deg2rad(lat2-lat1),  // deg2rad below
            dLon = deg2rad(lon2-lon1),
            a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
                Math.sin(dLon/2) * Math.sin(dLon/2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        return R * c; // Distance in km;
    }
    /**
     * create infoWindow html content
     *
     * @return  {String}
     */
    createInfoWindowContent() {
        return `<div class="info-window" ph-gtm-item data-ph-id="${this.#codiceX3}">
            ${this.isPharmacyActive() == true ? `<div class="info-window__row ph__active">
                <span class="ph__active__text">${theme.pharmacyLocator['strings']['pharmacyActiveFavInfoWindow']}</span>
            </div>`: ''}
            ${this.#aderenteReteFP == 1 ? `<div class="info-window__row ph__fp">
                <div class="ph__fp__text">
                    <span>${theme.pharmacyLocator['strings']['pharmacyFpGroup']}</span>
                </div>
            </div>` : ''}
            <div class="info-window__row ph__title">
                <div class="ph__title__text">
                    <h5>${this.#nomeFarmacia}</h5>
                </div>
            </div>
            <div class="info-window__row ph__address">
                <div class="ph__address__text">
                    <address>${this.getAddress()}</address>
                </div>
            </div>
            ${this.#telefono != '' ? `<div class="info-window__row ph__phone">
                <a href="tel:${this.#telefono}" data-gtm-type="tel">
                    ${this.#telefono}
                </a>
            </div>`: ''}
            <div class="info-window__row ph__details">
                <a href="javascript:" class="ph-map__item__btn theme-btn theme-btn--outline theme-btn--small ph-map__item__margin" ph-map-detail info-window-detail data-ph-id="${this.#codiceX3}" data-gtm-type="dettagli">
                    ${theme.pharmacyLocator['strings']['pharmacyDetails']}
                </a>
            </div>
            <div class="info-window__row ph__directions">
                <a href="https://www.google.com/maps/dir/?api=1&destination=${this.#lat},${this.#lng}" target="_blank" class="ph-map__item__btn theme-btn theme-btn--outline theme-btn--small" ph-map-directions data-ph-id="${this.#codiceX3}" data-gtm-type="indicazioni">
                    ${theme.pharmacyLocator['strings']['pharmacyIndication']}
                </a>
            </div>
        </div>`;
    }
    /**
     * create HTML Pharmacy box
     *
     * @return  {String}
     */
    createPharmacyBox (listPosition, self) {
        return `<li class="ph-map__item" ph-map-item ph-gtm-item data-ph-id="${this.#codiceX3}" ${this.isPharmacyActive() == true ? `data-ph-style`: ''}>
            ${this.isPharmacyActive() == true ? `<div class="ph-map__item__row ph-map__ph__active">
                <span class="ph-map__ph__text">${theme.pharmacyLocator['strings']['pharmacyActiveFav']}</span>
                <i class="ph-map__info__icon--white" ph-map-info data-modal="ph_fav_selected_modal" onclick="theme.modal('ph_fav_selected_modal');"></i>
            </div>`: ''}
            ${this.#aderenteReteFP == 1 ? `<div class="ph-map__item__row">
                <div class="ph-map__item__type">
                    <span>
                        ${theme.pharmacyLocator['strings']['pharmacyFpGroup']}
                    </span>
                </div>
            </div>` : ''}
            <div class="ph-map__item__row" data-code="${this.#codiceX3}" data-select="${this.#selectable ? this.#selectable : 'not-selectable'}"
                 data-position="${listPosition}">
                <div class="ph-map__item__det">
                    <h5>${this.#nomeFarmacia}</h5>
                    <address>${this.getAddress()}</address>
                </div>
            </div>
            <div class="ph-map__item__row ph-map__item__block">
                <div class="ph-map__item__wrapper">
                    <span class="ph-map__item__km ph-map__item__margin">
                        <svg class="anim" height="22" width="22">
                            <use href="#theme_svg_distance" xlink:href="#theme_svg_distance"/>
                        </svg>
                        <div>
                            ${parseFloat(this.distanceFromCenter).toFixed(1)} km
                        </div>
                    </span>
                    <div>
                        <a href="javascript:" class="ph-map__item__link ph-map__item__margin" ph-map-highlight-marker data-ph-id="${this.#codiceX3}" data-gtm-type="mostra mappa">${theme.pharmacyLocator['strings']['pharmacyShowOnMap']}</a>
                    </div>
                </div>
                <div class="ph-map__item__wrapper ph-map__item__directions--mobile">
                    <svg class="anim" height="22" width="22">
                        <use href="#theme_svg_directions_mob" xlink:href="#theme_svg_directions_mob"/>
                    </svg>
                    <a href="https://www.google.com/maps/dir/?api=1&destination=${this.#lat},${this.#lng}" target="_blank" class="ph-map__item__link" ph-map-highlight-marker data-ph-id="${this.#codiceX3}">
                        ${theme.pharmacyLocator['strings']['pharmacyIndication']}
                    </a>
                </div>
                ${ self.showProps.phone ? `
                    <div class="ph-map__item__wrapper ph-map__item__tel">
                        <svg class="anim" height="22" width="22">
                            <use href="#theme_svg_callus" xlink:href="#theme_svg_callus"/>
                        </svg>
                        <a href="tel:${this.#telefono}" class="ph-map__item__link" ph-map-item-tel data-gtm-type="tel">
                            ${this.#telefono}
                        </a>
                    </div>`: ''}
            </div>
            <div class="ph-map__item__row">
                <a href="javascript:" class="ph-map__item__btn theme-btn theme-btn--outline theme-btn--small ph-map__item__margin" ph-map-detail data-ph-id="${this.#codiceX3}" data-gtm-type="dettagli">
                    ${theme.pharmacyLocator['strings']['pharmacyDetails']}
                </a>
                <a href="https://www.google.com/maps/dir/?api=1&destination=${this.#lat},${this.#lng}" target="_blank" class="ph-map__item__directions--desk ph-map__item__btn theme-btn theme-btn--outline theme-btn--small" ph-map-directions data-ph-id="${this.#codiceX3}" data-gtm-type="indicazioni">
                    ${theme.pharmacyLocator['strings']['pharmacyIndication']}
                </a>
            </div>
            ${window.customerNoPh || !this.#selectable ? '' :
            `${this.isPharmacyActive() == false ? `<div class="ph-map__item__row row__ph__item--align">
                <a class="ph-map__item__btn theme-btn theme-btn--outline theme-btn--small"
                    data-select="${this.#selectable}" data-ph-id="${this.#codiceX3}" data-position="${listPosition}"
                    data-active="false" href="javascript:" ph-map-set-ph ph-set-type="listing">
                    ${theme.pharmacyLocator['strings']['pharmacyFav']}
                    </a>
                    <i class="ph-map__info__icon" ph-map-info data-modal="ph_fav_modal" onclick="theme.modal('ph_fav_modal');"></i>
             </div>` : ''}`
            }
        </li>`;
    }
}

class PharmacyDetails extends Pharmacy {
    #email;
    #facebookLink;
    #farmacieDiTurno;
    #instagramLink;
    #logoFarmacia;
    #orarioFarmacia;
    #listaServizi;
    #ragioneSociale1;
    #tikTokLink;
    #urlPaginaFarmacia;
    #urlSitoWeb;
    constructor(pharmacy) {
        super(pharmacy);
        this.#email = pharmacy.Email;
        this.#facebookLink = pharmacy.FacebookLink;
        this.#farmacieDiTurno = pharmacy.FarmacieDiTurno;
        this.#instagramLink = pharmacy.InstagramLink;
        this.#logoFarmacia = pharmacy.LogoFarmacia;
        this.#orarioFarmacia = this.#getPhTimetable(pharmacy.OrarioFarmacia);
        this.#ragioneSociale1 = pharmacy.RagioneSociale1;
        this.#tikTokLink = pharmacy.TikTokLink;
        this.#urlPaginaFarmacia = this.#getPhPageUrl(pharmacy.NomeFarmacia, pharmacy.CodiceX3);
        this.#urlSitoWeb = pharmacy.UrlSitoWeb;
        this.#listaServizi = this.#getServicesList(this.serviceDetails);
    }
    /**
     * create pharmacy timetable Stirng
     * @param {Object} orarioFarmacia
     *
     * @return  {String}
     */
    #getPhTimetable(orarioFarmacia) {
        if (orarioFarmacia === '') return `<small class="ph-map__details__not-availabe">${theme.pharmacyLocator['strings']['dataNotAvailable']}</small>`;
        const timePh = JSON.parse(orarioFarmacia);
        let timetable = '';

        for(let i in timePh) {
            const el = timePh[i];
            timetable += `<tr><td class="tt-day">${window.theme.pharmacyLocator.strings.weekdays[i]}</td><td>`;
            if (el.IsOpen) {
                if (el.MorningFrom != '' && el.MorningFrom != '00:00') timetable += el.MorningFrom;
                if (el.MorningTo != '' && el.MorningTo != '00:00') timetable += ` ${el.MorningTo}`;
                if (el.AfternoonFrom != '' && el.AfternoonFrom != '00:00') timetable += ` - ${el.AfternoonFrom}`;
                if (el.AfternoonTo != '' && el.AfternoonTo != '00:00') timetable += ` ${el.AfternoonTo}`;
            } else {
                timetable += window.theme.pharmacyLocator.strings.pharmacyClosed;
            }
            timetable += `</td></tr>`;
        }
        if(timetable != '') timetable = `<table>${timetable}</table>`;

        return timetable;
    }
    /**
     * return full ph details page url
     * @param {String} nomeFarmacia
     * @param {Number} codiceX3
     *
     * @return  {String}
     */
    #getPhPageUrl(nomeFarmacia, codiceX3) {
        return !window.customerLogged ? `/pages/farmacia-dettaglio?n=${encodeURIComponent(nomeFarmacia)}&id=${codiceX3}` : '/account?view=pharmacy';
    }
    /**
     * return ph services list
     * @param {Object} services
     *
     * @return  {String}
     */
    #getServicesList(services){
        let servicesList = '';
        for (let i in services) servicesList += `<li><svg class="anim" height="7" width="10"><use href="#theme_svg_checkmark" xlink:href="#theme_svg_checkmark"/></svg>${services[i]}</li>`;
        return (servicesList != '') ? `<ul class="ph-map__details__services-list">${servicesList}</ul>` : `<small class="ph-map__details__not-availabe">${theme.pharmacyLocator['strings']['dataNotAvailable']}</small>` ;
    }
    /**
     * create HTML Pharmacy Details
     *
     * @return  {String}
     */
    createPharmacyDetails(self) {
        const contacts =`${this.telefono != '' && this.telefono != null && self.showProps.phone ? `<a href="tel:${this.telefono}" class="ph-map__results__details__text-icon" data-gtm-type="tel">
                            <svg class="anim" height="22" width="22">
                                <use href="#theme_svg_phone" xlink:href="#theme_svg_phone" />
                            </svg>
                            ${this.telefono}
                        </a>` : ''}
                        ${this.#email != '' && this.#email != null && self.showProps.email ? `<a class="ph-map__results__details__text-icon" href="mailto:${this.#email}" target="_blank" data-gtm-type="mail">
                            <svg class="anim" height="22" width="22">
                                <use href="#theme_svg_email" xlink:href="#theme_svg_email"/>
                            </svg>
                            ${this.#email}
                        </a>` : ''}
                        ${this.#urlSitoWeb != '' && this.#urlSitoWeb != null ? `<a class="ph-map__results__details__text-icon" href="${this.#urlSitoWeb}" target="_blank" data-gtm-type="sito">
                            <svg class="anim" height="22" width="22">
                                <use href="#theme_svg_website" xlink:href="#theme_svg_website"/>
                            </svg>
                            ${this.#urlSitoWeb}
                        </a>` : ''}
                        ${this.#facebookLink != '' && this.#facebookLink != null ? `<a href="${this.#facebookLink}" class="ph-map__results__details__text-icon" target="_blank" data-gtm-type="facebook">
                            <svg class="anim" height="22" width="22">
                                <use href="#theme_svg_social_fb" xlink:href="#theme_svg_social_fb"/>
                            </svg>
                            ${this.#facebookLink}
                        </a>` : ''}
                        ${this.#instagramLink != '' && this.#instagramLink != null ? `<a href="${this.#instagramLink}" class="ph-map__results__details__text-icon" target="_blank" data-gtm-type="instagram">
                            <svg class="anim" height="22" width="22">
                                <use href="#theme_svg_social_insta" xlink:href="#theme_svg_social_insta"/>
                            </svg>
                            ${this.#instagramLink}
                        </a>` : ''}
                        ${this.#tikTokLink != '' && this.#tikTokLink != null ? `<a href="${this.#tikTokLink}" class="ph-map__results__details__text-icon" target="_blank" data-gtm-type="tiktok">
                            <svg class="anim" height="22" width="22">
                                <use href="#theme_svg_social_tiktok" xlink:href="#theme_svg_social_tiktok"/>
                            </svg>
                            ${this.#tikTokLink}
                        </a>` : ''}
                        ${this.#farmacieDiTurno != '' && this.#farmacieDiTurno != null ? `<a href="${this.#farmacieDiTurno}" class="ph-map__results__details__text-icon" target="_blank">
                            <svg class="anim" height="22" width="22">
                                <use href="#theme_svg_check" xlink:href="#theme_svg_check"/>
                            </svg>
                            ${this.#farmacieDiTurno}
                        </a>` : ''}`;

        return `<div class="ph-map__results__details__content${this.isPharmacyActive() == true ? ' ph-map__detail-active': ''}" ph-gtm-item data-ph-id="${this.codiceX3}">
            ${this.isPharmacyActive() == true ? `<div class="ph-map__item__row ph-map__ph__active">
                <span class="ph-map__ph__text">${theme.pharmacyLocator['strings']['pharmacyActiveDetails']}</span>
                <i class="ph-map__info__icon--white" ph-map-info data-modal="ph_fav_selected_modal" onclick="theme.modal('ph_fav_selected_modal');"></i>
            </div>`: ''}
            ${this.#logoFarmacia != '' ? `<div class="ph-map__item__row">
                <img src="${this.#logoFarmacia}" alt="${theme.pharmacyLocator['strings']['pharmacyLogoAlt']}" class="ph-map__results__details__img"/>
            </div>` : ''}
            ${this.aderenteReteFP == 1 ? `<div class="ph-map__item__row">
                <div class="ph-map__item__type">
                    <span>
                        ${theme.pharmacyLocator['strings']['pharmacyFpGroup'].toUpperCase()}
                    </span>
                </div>
            </div>` : ''}
            <div class="ph-map__item__row ph__info">
                <div class="ph-map__item__det">
                    ${this.nomeFarmacia != null ? `<h5 class="ph-map__item__title">
                        ${this.nomeFarmacia.toUpperCase()}
                    </h5>` : ''}
                    ${this.#ragioneSociale1 != '' && self.showProps.bname ? `<div class="ragione_sociale">
                        <div class="ph-map__results__details__subtitle">${theme.pharmacyLocator['strings']['ragioneSociale'].toUpperCase()}: <span>${this.#ragioneSociale1.toLowerCase()}</span></div>
                    </div>` : ''}
                    <address>${this.getAddress()}</address>
                </div>
            </div>
            <div class="ph-map__item__row ph__map">
                <a href="https://www.google.com/maps/dir/?api=1&destination=${this.lat},${this.lng}" target="_blank" class="ph-map__item__btn theme-btn theme-btn--outline theme-btn--small ph-map__item__margin" data-ph-id="${this.codiceX3}" data-gtm-type="indicazioni">
                    ${theme.pharmacyLocator['strings']['pharmacyIndication']}
                </a>
                <a href="javascript:" class="ph-map__item__link ph-map__item__margin" ph-map-highlight-marker data-ph-id="${this.codiceX3}" data-gtm-type="mostra mappa">
                    ${theme.pharmacyLocator['strings']['pharmacyShowOnMap']}
                </a>
            </div>
            ${contacts.trim() != '' ?
                `<div class="ph-map__item__row pharmacy-contacts">
                    <p class="ph-map__results__details__subtitle">${theme.pharmacyLocator['strings']['contacts']}</p>
                    ${contacts}
                </div>`
            : ''}
            ${this.#orarioFarmacia != '' && this.#orarioFarmacia != null ? `<div class="ph-map__item__row time_table">
                <span class="ph-map__results__details__subtitle">${theme.pharmacyLocator['strings']['timetable'].toUpperCase()}</span>
                <div class="ph-map__results__details__timetable">${this.#orarioFarmacia}</div>
            </div>` : ''}
            ${this.#listaServizi != '' ? `<div class="ph-map__item__row services">
                <span class="ph-map__results__details__subtitle">${theme.pharmacyLocator['strings']['services'].toUpperCase()}</span>
                <div class="ph-map__results__details__services">${this.#listaServizi}</div>
            </div>` : ''}
            ${this.isPharmacyActive() == true ? `<div class="ph-map__item__row row__ph__active--bottom">
                <span class="ph-map__ph__text">${theme.pharmacyLocator['strings']['pharmacyActiveDetails']}</span>
                <i class="ph-map__info__icon" ph-map-info data-modal="ph_fav_selected_modal" onclick="theme.modal('ph_fav_selected_modal');"></i>
            </div>`: ''}
            ${window.customerNoPh || !this.selectable ? '' :
            `<div class="ph-map__item__row row__ph__item--align">
                ${this.isPharmacyActive() == false ? `<a class="ph-map__item__btn theme-btn theme-btn--outline theme-btn--small"
                    data-select="${this.selectable}" data-ph-id="${this.codiceX3}"
                    data-active="false" href="javascript:" ph-map-set-ph ph-set-type="detail">
                    ${theme.pharmacyLocator['strings']['pharmacyFav']}
                </a>
                <i class="ph-map__info__icon" ph-map-info data-modal="ph_fav_modal" onclick="theme.modal('ph_fav_modal');"></i>` : `<a class="ph-map__item__btn theme-btn theme-btn--small theme-btn--blue"
                    data-select="${this.selectable}" data-code="${this.codiceX3}"
                    data-active="true" href="/">
                    ${theme.pharmacyLocator['strings']['startBuying']}
                </a>`}
            </div>`}
            ${ !this.selectable ? '' :
            `<div class="ph-map__item__row">
                <a href="${this.#urlPaginaFarmacia}" class="ph-map__item__btn theme-btn theme-btn--outline theme-btn--small" data-code="${this.codiceX3}">${theme.pharmacyLocator['strings']['pharmacyGoToPage']}</a>
            </div>`}
        </div>`;
    }
}
